import React from 'react';
import PropTypes from 'prop-types';
//import './ProductTineConfigurationView.scss';
import QuoteProductDetail from '../../../quotes/entities/quoteProductDetail';

export default class ProductTineConfigurationView extends React.PureComponent {
  static propTypes = {
    entity: PropTypes.instanceOf(QuoteProductDetail).isRequired,
  };

  render() {
    const { entity } = this.props;

    return (
      <div>
        <div className="hr-divider inverse">
          <h3 className="hr-divider-content hr-divider-heading">
            Tine Configuration
          </h3>
        </div>
        <div className="row">
          <div className="col-6">
            <div className="text-center">
              Based on the bucket & coupler information{' '}
            </div>
            <div className="text-center">
              provided, we have determined your thumb
            </div>
            <div className="text-center">
              will require a tip radius of{' '}
              <span className="yellow-count">{entity.thumbTipRadius}"</span>
            </div>
          </div>
          <div className="col-6">
            <div className="text-center">
              Please review the below image which illustrates how{' '}
            </div>
            <div className="text-center">
              the thumb tines will interact with the bucket.
            </div>
            <div className="text-center">
              If you have any questions, please contact AMI.
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-6">
            <img
              className="img-thumbnail"
              id="tipRadiusSideViewBase64Image"
              alt="AMI"
              src={entity.tipRadiusDiagram.imageUrl}
            />
          </div>
          <div className="col-6">
            <img
              className="img-thumbnail"
              id="thumbBodyBase64Image"
              alt="AMI"
              src={entity.tineDiagram.imageUrl}
            />
          </div>
        </div>
      </div>
    );
  }
}
